import { Icon } from './Icon';
import type { IEmptyStateProps } from './IEmptyStateProps';

/** Порожній стан списку, подання або панелі (UIUX/patterns/empty-states): речення + основна дія, ніколи не порожня область. */
export function EmptyState({ text, action, icon }: IEmptyStateProps) {
  return (
    <div className="empty">
      {icon && <Icon name={icon} size={20} className="empty__icon" />}
      <p className="empty__text">{text}</p>
      {action && <div className="empty__action">{action}</div>}
    </div>
  );
}
